import { render, staticRenderFns } from "./ProductMigrationState.vue?vue&type=template&id=0d483d3e&"
import script from "./ProductMigrationState.vue?vue&type=script&lang=ts&"
export * from "./ProductMigrationState.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports